module.exports = {//例子 this.$i18n.t('main.submit_audit')  {{$t('main.status_name')}}

    main:{
        chef              :'戈登·拉姆齐',
        brand             :'米其林',
        contact           :'联系信息',
        manager           :'餐厅经理',
        menu              :'菜单',
        course_menu       :'套餐菜单',
        pax               :'人数',
        gallery           :'图库',
        
    }

}